module.exports = __webpack_public_path__ + "static/9-dc333136e1d1d82d4fa319d92a48c22d.png";